import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

interface ErrorStateProps {
  message?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message }) => (
  <div className="error-container" role="alert">
    <FontAwesomeIcon icon={faExclamationCircle} />
    {message ||
      "Something went wrong. Please try refreshing the page, or call 1.888.511.6548 for support if the problem persists."}
  </div>
);

export default ErrorState;
